import {takeEvery} from 'redux-saga/effects'
import 'setup/redux/Actions/Subject/ActionTypes/ApiActionTypes'
import {
  ACTIVATE_VERSION,
  ADD_CONSTRAINT_BY_ID,
  ADD_NEW_DURATION,
  BULK_UPDATE_WORKLOAD,
  CALCULATE_TIMETABLE_TOKENS,
  CHECK_ALL_SUBJECTS_ENROLLMENT,
  CREATE_TIMETABLE_CLASS_VENUES,
  DEACTIVATE_VERSION,
  DELETE_CONSTRAINT,
  DELETE_DURATION,
  DELETE_TIMETABLE,
  DELETE_TIMETABLE_VERSION,
  DIAGNOSE_TIMETABLE_FAILURES,
  GENERATE_PROMPT,
  GENERATE_TIMETABLE_REPORT_PDF,
  GET_ACCESS_TOKEN,
  GET_ALL_CONSTRAINTS,
  GET_ALL_DURATIONS,
  GET_ALL_VERSIONS,
  GET_CONSTRAINT_BY_ID,
  GET_FREE_TEACHERS,
  GET_FREE_VENUES,
  GET_RECENT_TIMETABLE_VERSIONS,
  GET_SAMPLE_GENERATION_STATUS,
  GET_TIMETABLE,
  GET_TIMETABLE_CATEGORIES,
  GET_TIMETABLE_LIST_DATA,
  GET_TIMETABLE_REPORT,
  GET_TIMETABLE_STATUS,
  GET_TIMETABLE_STUDENT_SUBJECTS,
  GET_TIMETABLE_SUBCATEGORIES,
  GET_TIMETABLE_SUBCATEGORY_BY_ID,
  GET_TIMETABLE_WARNING,
  GET_WORK_BREAK_DOWN_BY_LEVEL_ID,
  LOG_SOCKET_MESSAGE,
  LOG_TIMETABLE_EXPORT,
  TRACK_TIMETABLE_EVENT,
  UPDATE_CONSTRAINT,
  UPDATE_CONSTRAINT_LIST,
  UPDATE_DURATION,
  UPDATE_TIMETABLE,
  UPDATE_VERSION_NAME,
  UPDATE_WORK_BREAK_DOWN_FREQUENCY,
  VALIDATE_CLASS_SUBJECT_LOAD,
  VALIDATE_CONCURRENT_SUBJECTS,
  VALIDATE_SUBJECT_PAIRS_CONCURRENT,
  VALIDATE_TEACHER_AVAILABILITY,
  VALIDATE_TIMETABLE,
  VALIDATE_TIMETABLE_CAPACITY,
} from 'setup/redux/Actions/Timetable/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ACCESS_TOKEN, fetchData)
  yield takeEvery(GET_TIMETABLE_CATEGORIES, fetchData)
  yield takeEvery(GET_TIMETABLE_SUBCATEGORIES, fetchData)
  yield takeEvery(GET_TIMETABLE_SUBCATEGORY_BY_ID, fetchData)
  yield takeEvery(ADD_CONSTRAINT_BY_ID, fetchData)
  yield takeEvery(GET_ALL_CONSTRAINTS, fetchData)
  yield takeEvery(DELETE_CONSTRAINT, fetchData)
  yield takeEvery(GET_CONSTRAINT_BY_ID, fetchData)
  yield takeEvery(UPDATE_CONSTRAINT, fetchData)
  yield takeEvery(GET_TIMETABLE, fetchData)
  yield takeEvery(UPDATE_TIMETABLE, fetchData)
  yield takeEvery(DELETE_TIMETABLE, fetchData)
  yield takeEvery(GET_TIMETABLE_REPORT, fetchData)
  yield takeEvery(GENERATE_PROMPT, fetchData)
  yield takeEvery(VALIDATE_TIMETABLE, fetchData)
  yield takeEvery(VALIDATE_TEACHER_AVAILABILITY, fetchData)
  yield takeEvery(GET_TIMETABLE_STATUS, fetchData)
  yield takeEvery(GET_SAMPLE_GENERATION_STATUS, fetchData)
  yield takeEvery(LOG_SOCKET_MESSAGE, fetchData)
  yield takeEvery(GENERATE_TIMETABLE_REPORT_PDF, fetchData)
  yield takeEvery(ADD_NEW_DURATION, fetchData)
  yield takeEvery(UPDATE_DURATION, fetchData)
  yield takeEvery(GET_ALL_DURATIONS, fetchData)
  yield takeEvery(DELETE_TIMETABLE_VERSION, fetchData)
  yield takeEvery(GET_ALL_VERSIONS, fetchData)
  yield takeEvery(ACTIVATE_VERSION, fetchData)
  yield takeEvery(DEACTIVATE_VERSION, fetchData)
  yield takeEvery(UPDATE_VERSION_NAME, fetchData)
  yield takeEvery(DELETE_DURATION, fetchData)
  yield takeEvery(GET_TIMETABLE_LIST_DATA, fetchData)
  yield takeEvery(GET_TIMETABLE_STUDENT_SUBJECTS, fetchData)
  yield takeEvery(GET_ACCESS_TOKEN, fetchData)
  yield takeEvery(GET_WORK_BREAK_DOWN_BY_LEVEL_ID, fetchData)
  yield takeEvery(UPDATE_WORK_BREAK_DOWN_FREQUENCY, fetchData)
  yield takeEvery(GET_TIMETABLE_WARNING, fetchData)
  yield takeEvery(VALIDATE_CONCURRENT_SUBJECTS, fetchData)
  yield takeEvery(UPDATE_CONSTRAINT_LIST, fetchData)
  yield takeEvery(CREATE_TIMETABLE_CLASS_VENUES, fetchData)
  yield takeEvery(BULK_UPDATE_WORKLOAD, fetchData)
  yield takeEvery(VALIDATE_TIMETABLE_CAPACITY, fetchData)
  yield takeEvery(VALIDATE_SUBJECT_PAIRS_CONCURRENT, fetchData)
  yield takeEvery(GET_FREE_TEACHERS, fetchData)
  yield takeEvery(GET_FREE_VENUES, fetchData)
  yield takeEvery(DIAGNOSE_TIMETABLE_FAILURES, fetchData)
  yield takeEvery(CALCULATE_TIMETABLE_TOKENS, fetchData)
  yield takeEvery(CHECK_ALL_SUBJECTS_ENROLLMENT, fetchData)
  yield takeEvery(GET_RECENT_TIMETABLE_VERSIONS, fetchData)
  yield takeEvery(VALIDATE_CLASS_SUBJECT_LOAD, fetchData)
  yield takeEvery(LOG_TIMETABLE_EXPORT, fetchData)
  yield takeEvery(TRACK_TIMETABLE_EVENT, fetchData)
}

export default dataSaga
